import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  REDUX_BOOKING_SERVICES,
  REDUX_STORE_DEFAULTS,
} from "../../store/config"
import { bookingAction } from "../../store/actions/bookingAction"
import { AppointmentData } from "../../config/bookingDataConfig"
import {
  updateBookingData,
  updateData,
  updateVehicleData,
} from "../../store/actions/multipleBookingAction"
import {
  getServiceOptions,
  getVehicleOptions,
} from "../../services/api/apiModule"
import { lowerCase } from "lodash"
import { getServices } from "../../store/actions/serviceAction"

const SelectStaff = () => {
  const [isStaffselected, setIsStaffSelected] = useState()
  const dispatch = useDispatch()
  let {
    bookingStepsLabel,
    stepNo,
    location,
    staffCategory,
    service,
    multipleBookingStatus,
  } = useSelector((state) => state.bookingReducer)

  let { allBookingData } = useSelector((state) => state.multipleBookingReducer)
  let { allVehicles } = useSelector((state) => state.serviceReducer)
  const [allVehicleList, setAllVehicleList] = useState([])

  useEffect(() => {
    if (allVehicles) {
      setAllVehicleList(allVehicles)
    }
  }, [allVehicles])

  const fetchServicesList = async (locationType, staffId) => {
    try {
      const res = await getServiceOptions(locationType, staffId)
      console.log(res, "service options")
      if (res.success) {
        dispatch(
          getServices(
            REDUX_BOOKING_SERVICES.GET_SERVICE_CATEGORY(),
            res.data.category
          )
        )
      }
    } catch (error) {}
  }

  const submitHandler = (propValue) => {
    setIsStaffSelected(propValue._id)
    // console.log("Staff", propValue, "and", staffCategory);
    dispatch(getServices(REDUX_BOOKING_SERVICES.GET_SERVICE_CATEGORY(), []))

    const staffData = {
      id: propValue._id,
      staffDisplayName: propValue.serviceOption,
      staffImgUrl: propValue.imgUrl,
      // description: propValue.description,
      // staffDiscount: propValue.staffDiscount,
      // availablelocation: propValue.availablelocation,
      // type: propValue.type,
    }
    if (staffCategory.id === propValue._id) {
      dispatch(
        dispatch(bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_STAFF(), {}))
      )
      dispatch(updateData({}, 2, multipleBookingStatus))
    } else {
      dispatch(
        dispatch(
          bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_STAFF(), staffData)
        )
      )
      dispatch(updateData(staffData, 2, multipleBookingStatus))
      fetchServicesList(lowerCase(location.locationRole), propValue._id)
      // setTimeout(() => {
      //   dispatch(
      //     bookingAction(REDUX_STORE_DEFAULTS.UPDATE_BOOKING_STEPS(), stepNo + 1)
      //   )
      // }, 100)
      // dispatch(updateVehicleData(staffData, !multipleBookingStatus))
    }
  }

  return (
    <>
      <div className="space-y-4 w-full">
        <h1>Select Vehicle Type</h1>
        <div className="flex flex-row flex-wrap justify-center sm:justify-start">
          {allVehicleList.length ? (
            allVehicleList.map((value, key) => {
              return (
                <>
                  <div
                    key={key + "staff"}
                    className={` cursor-pointer h-[10rem] sm:w-[11rem] w-[9rem] m-3 flex flex-col items-center justify-center rounded-xl backdrop-blur-xl overflow-hidden ${
                      staffCategory.id === value._id
                        ? "bg-yellow-medium_dark bg-opacity -35 shadow shadow-white"
                        : "border-2 border-yellow-light_medium"
                    } `}
                    // title={`${
                    //   value?.isAvailable
                    //     ? value.serviceOption
                    //     : "Not avalable For Selected location"
                    // } `}
                    onClick={(e) => {
                      submitHandler(value)
                    }}
                  >
                    <img
                      src={value.imgUrl}
                      alt="staff"
                      className="object-cover w-32"
                      loading="lazy"
                    />
                    <span className="capitalize mt-2">
                      {value.serviceOption}
                    </span>
                    <span className="capitalize text-xs text-slate-100">
                      {value?.description}
                    </span>
                    {value?.ribbon && (
                      <div
                        className={`absolute w-[10rem] text-center top-[1.5rem] -right-[3rem] text-white bg-yellow-light rotate-45 capitalize shadow-md shadow-white`}
                      >
                        <span>{value?.ribbon}</span>
                      </div>
                    )}
                  </div>
                </>
              )
            })
          ) : (
            <div className="flex justify-center flex-1">
              <span>loading....</span>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default SelectStaff
